(function () {
  function initSlick() {
    if (window.jQuery && jQuery.fn.slick) {
      jQuery('.coll_list_slider').slick({
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 300,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow:
          '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0126/6732/2432/files/left-arrow_103a5177-6f1d-4733-9c43-ee580401497f.png?v=1668681677"></div>',
        nextArrow:
          '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0126/6732/2432/files/next.png?v=1668681677"></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              centerMode: true,
              centerPadding: "40px"
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              centerMode: true,
              centerPadding: "40px"
            }
          }
        ]
      });
    } else {
      setTimeout(initSlick, 300);
    }
  }

  document.addEventListener("DOMContentLoaded", initSlick);
})();
